import _defineProperty from"/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}import{CommonUtils}from'utils';import axios from'../axios';import*as queryString from'query-string';import moment from'moment';import config from'../combineConfig';var transferService={/**
     * Kiểm tra thông tin giao dịch chuyển tiền.
     */checkCashTransfer:function checkCashTransfer(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkCashTransfer"),transferBody);},//pre check chuyển tiền nội bộ
checkInternalTransfer:function checkInternalTransfer(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkInternalTransfer"),transferBody);},//pre check chuyển tiền ra ngoài hoặc ra ngoài cùng tên
checkExternalTransfer:function checkExternalTransfer(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkExternalTransfer"),transferBody);},/**
    * Pre check hủy lệnh chuyển tiền ngoài giờ.
    */checkCashTransferOverTime:function checkCashTransferOverTime(accountId,reqid){return axios.post("/tran/accounts/".concat(accountId,"/checkCancelCashTransferOvertime"),reqid);},/**
     * Hủy lệnh chuyển tiền ngoài giờ.
     */cancelCashTransferOvertime:function cancelCashTransferOvertime(reqid){return axios.post("/tran/cancelCashTransferOvertime",reqid);},/**
     * Check đăng ký xác thực 2 lớp
     */preCheckRegisterSmsOtp:function preCheckRegisterSmsOtp(reqid){return axios.post("/tran/registerSmsotp/request");},registerSMSOtp:function registerSMSOtp(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/registerSmsotp",body);},/**
     * Kiểm tra thông tin mã giấy tờ.
     * idcode: mã giấy tờ (CMND
     * )
     */checkIdcode:function checkIdcode(accountId,idcode){return axios.post("/tran/accounts/".concat(accountId,"/checkIdcode"),idcode);},/**
     * Thực hiện giao dịch chuyển tiền ra ngoài
     * {
     *  "benefitBank": "CN NHDT&PT THANH PHO HO CHI MINH",
     *  "benefitAccount": "31012000024935",
     *  "benefitName": "HUA THI TUYET TRINH",
     *  "benefitLisenseCode": "060509182",
     *  "amout": 10000000,
     *  "feeAmount": 5000,
     *  "vatAmount": 500,
     *  "feeType": "inFee",
     *  "transDescrtiption": "Chuyen tien"
     * }
     */processExternalTransfer:function processExternalTransfer(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/externalTransfer"),body);},/**
    * Thực hiện giao dịch chuyển tiền ra ngoài với CMTND
    * 
        {
            'transactionId'="0001000320:CASHTRANS:1634972883237"' 
            'tokenid="029C000340"' 
            'code="123"' 
            'benefitBank="1"' 
            'benefitAccount="0001000391"' 
            'benefitName="aaaaa"' 
            'amout="100000"' 
            'branchid="2"',
            'transDescrtiption' = "aaaa"
        }
    * 
    */processCashTransferWithIdCode:function processCashTransferWithIdCode(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/externalTransferSameName"),data);},/**
     * Thực hiện giao dịch chuyển tiền nội bộ
     * {
     *  "receiveAccount": "0001000002",
     *  "amout": 10000000,
     *  "transDescrtiption": "Chuyen tien"
     * }
     */processInternalTransfer:function processInternalTransfer(accountId,data){return axios.post("/tran/accounts/".concat(accountId,"/internalTransfer"),data);},/**
     * Thực hiện giao dịch chuyển tiền nội bộ
     * {
     *  "advanceAmt": 0,
     *  "description": "string"
     * }
     */processCashAdvance:function processCashAdvance(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/advanced"),body);},/**
     * Thực hiện kiểm tra giờ ứng trước tiền bán
     * {
     *  "advanceAmt": 0,
     *  "description": "string"
     * }
     */checkAdvanced:function checkAdvanced(accountId,checkAdvanceBody){return axios.post("/tran/accounts/".concat(accountId,"/checkAdvanced"),checkAdvanceBody);},/**
     * Check đăng ký ứng tiền tự động
     * {
     *  "isregis": 'Y',
     * }
     */checkRegisterOrCancelAdvance:function checkRegisterOrCancelAdvance(accountId,checkAdvanceBody){return axios.post("/tran/accounts/".concat(accountId,"/checkOnlineServicesRegister"),checkAdvanceBody);},/**
    * Thực hiện giao dịch đăng ký ứng tiền tự động
    * {
    *  "isregis": 'Y',
    * }
    */processRegisterOrCancelAdvance:function processRegisterOrCancelAdvance(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/onlineServicesRegister"),body);},/**
     * Đăng ký mua chứng khoán sự kiện quyền
     * {
     *  "camastId": "string",
     *  "qtty": 0,
     *  "description": "string"
     * }
     */processRightOffRegister:function processRightOffRegister(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/rightOffRegister"),body);},/**
    * Precheck gia hạn món vay
    * @param {*} accountId 
    * @returns 
    */checkLoanExtendDeal:function checkLoanExtendDeal(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/loan/checkExtendDeal"),body);},/**
     * Gia hạn món vay
     * {
     *  "autoid": "string",
     *  "todate": date,
     *  "transactionId": "string",
     *  "tokenid": "string"
     * }
     */processRightOffPayLoan:function processRightOffPayLoan(accountId,data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/loan/extendDeal"),body);},/**
    * Precheck trả nợ món vay
    * @param {*} accountId 
    * @returns 
    */checkLoanPaymentDeal:function checkLoanPaymentDeal(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/loan/checkPaymentDeal"),body);},/**
     * Trả nợ món vay
     * {
     *  "autoid": "string",
     *  "todate": date,
     *  "transactionId": "string",
     *  "tokenid": "string"
     * }
     */processRightOffPaymentLoan:function processRightOffPaymentLoan(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/loan/paymentDeal"),body);},/**
    * Thực hiện kiểm tra giờ Đăng ký quyền mua
    */checkRightOffRegister:function checkRightOffRegister(accountId,checkBondToShareBody){return axios.post("/tran/accounts/".concat(accountId,"/checkRightOffRegister"),checkBondToShareBody);},/**
     * Đăng ký chuyển đổi trái phiếu
     * {
     *  "caschdautoid": "string",
     *  "quantity": 0,
     *  "desc": "string"
     * }
     */processBondToShareRegister:function processBondToShareRegister(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,bondToShareRegisterBody:null};var accountId=data.accountId,bondToShareRegisterBody=data.bondToShareRegisterBody;return axios.post("/tran/accounts/".concat(accountId,"/bondsToShareRegister"),bondToShareRegisterBody);},/**
     * Thực hiện kiểm tra giờ ứng trước tiền bán
     * {
     *  "advanceAmt": 0,
     *  "description": "string"
     * }
     */checkBondToShareRegister:function checkBondToShareRegister(accountId,checkBondToShareBody){return axios.post("/tran/accounts/".concat(accountId,"/checkBondsToShareRegister"),checkBondToShareBody);},/**
     * Chuyển khoản chứng khoán nội bộ
     * {
     *  "receiveAccount": "string",
     *  "symbol": "string",
     *  "qtty": 0,
     *  "description": "string"
     * }
     */processTransferStock:function processTransferStock(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,transferBody:null};var accountId=data.accountId,transferBody=data.transferBody;return axios.post("/tran/accounts/".concat(accountId,"/tranferStock"),transferBody);},/**
     * Mua bán lại trái phiếu - 1 
     * {
     *  "custodycdSell": "string",
     *  "afacctnoSell": "string",
     *  "symbol": "string",
     *  "qtty": 0
     *  "price": 0
     *  "amt": 0
     *  "tdtype": "string"
     *  "desc": "string"
     * }
     */processBondsTranfer:function processBondsTranfer(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,bondsTranferBody:null};var accountId=data.accountId,bondsTranferBody=data.bondsTranferBody;return axios.post("/tran/accounts/".concat(accountId,"/bondsTranfer"),bondsTranferBody);},/**
    * Mua bán lại trái phiếu - 2
    * {
    *  "custodycdSell": "string",
    *  "afacctnoSell": "string",
    *  "symbol": "string",
    *  "qtty": 0
    *  "price": 0
    *  "amt": 0
    *  "tdtype": "string"
    *  "amt2": 0
    *  "txdate1": "string"
    *  "txnum1": "string"
    *  "taxamt": 0
    *  "desc": "string"
    * }
    */processBondsTranfer2:function processBondsTranfer2(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,transferBody:null};var accountId=data.accountId,transferBody=data.transferBody;return axios.post("/tran/accounts/".concat(accountId,"/bondsTranfer2"),transferBody);},/**
     * Chuyển món mua bán lại sang tự động ra hạn
     * @param accountid: Số tiểu khoản
     */bondsExtent:function bondsExtent(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,transferBody:null};var accountId=data.accountId,transferBody=data.transferBody;return axios.post("/tran/accounts/".concat(accountId,"/bondsExtent"),transferBody);},/**
     * Gửi lại mã xác thực cho phần giao dịch (không có tham số???)
     */resendAuthCode:function resendAuthCode(){return axios.post("/tran/resendAuthCode");},/**
     * 
     * Gửi mã xác thực 
     */gen2FactorCode:function gen2FactorCode(accountId,data){return axios.post("/tran/genTwoFactorAuth",data);},/**
     * Gửi mã xác thực với tiểu khoản phái sing
     * @param {*} accountId 
     * @param {*} data 
     * @returns 
     */gen2FactorCodeFds:function gen2FactorCodeFds(accountId,data){return axios.post("/tranfds/genTwoFactorAuth",data);},/**
     * Kiểm tra mã xác thực
     */process2FactorAuth:function process2FactorAuth(data){return axios.post("/tran/twoFactorAuth",data);},/**
     * Kiểm tra mua lại trái phiếu
     * {
     *  "accountId": Mã tiểu khoản,
     * }
     */checkBondsRepurchase:function checkBondsRepurchase(accountId,repurchasebody){return axios.post("/tran/accounts/".concat(accountId,"/checkBondsRepurchase"),repurchasebody);},/**
     * Kiểm tra Bán lại trái phiếu
     * {
     *  "accountId": Mã tiểu khoản,
     * }
     */checkBondsResell:function checkBondsResell(accountId,bondresellbody){return axios.post("/tran/accounts/".concat(accountId,"/checkBondsReSell"),bondresellbody);},/**
     * Kiểm tra gia hạn trái phiếu
     * {
     *  "accountId": Mã tiểu khoản,
     * }
     */checkBondsExtends:function checkBondsExtends(accountId,extendbody){return axios.post("/tran/accounts/".concat(accountId,"/checkBondsExtends"),extendbody);},/**
     * Thực hiện thay đổi số điện thoại 11 số
     * {
     *  "custid": "012312412432" // Số sổ tiết kiệm
     * }
     */changePhoneNumber:function changePhoneNumber(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{transferBody:null};var transferBody=data.transferBody;return axios.post("/tran/changePhoneNumber",transferBody);},/**
    * Kiểm tra thông tin gửi tiết kiệm
    * {
    *  "accountId": Mã tiểu khoản,
    * }
    */checkTermDeposit:function checkTermDeposit(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkTermDeposit"),transferBody);},/**
   * Kiểm tra thông tin gửi tiết kiệm
   * {
   *  "accountId": Mã tiểu khoản,
   * }
   */checkRegisterCancelIdeposit:function checkRegisterCancelIdeposit(accountId,registerCancelIDepositBody){return axios.post("/tran/accounts/".concat(accountId,"/checkRegisterCancelIdeposit"),registerCancelIDepositBody);},/**
     * Thực hiện đăng ký (hủy đăng ký giao dịch tiết kiệm)
     * {
     *  "accountId": "0001000002",
     *  "status": "Register", / "Cancel"
     *  "pnoneNumber": "0338761234"
     * }
     */processRegisterCancelIdeposit:function processRegisterCancelIdeposit(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/registerCancelIdeposit"),data);},/**
     * Thực hiện đăng ký (hủy đăng ký giao dịch ibond)
     * {
     *  "accountId": "0001000002",
     *  "status": "Register", / "Cancel"
     *  "pnoneNumber": "0338761234"
     * }
     */processRegisterCancelIBond:function processRegisterCancelIBond(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{accountId:null,registerBody:null};var accountId=data.accountId,registerBody=data.registerBody;return axios.post("/tran/accounts/".concat(accountId,"/registerCancelIBond"),registerBody);},/**
     * 
     * @param accountId mã tiểu khoản
     * @param withdrawBody body chứa đầu vào check
     */checkDepositWithdraw:function checkDepositWithdraw(accountId,withdrawBody){return axios.post("/tran/accounts/".concat(accountId,"/checkDepositWithdraw"),withdrawBody);},/**
     * 
     * @param accountId mã tiểu khoản
     * @param transferBody body chứa đầu vào check
     */checkDepositTransfer:function checkDepositTransfer(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkDepositTransfer"),transferBody);},/**
     * 
     * @param transferBody body chứa đầu vào check
     */checkDepositExtend:function checkDepositExtend(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkDepositExtend"),transferBody);},/**
     * 
     * @param accountId mã tiểu khoản
     * @param transferBody body chứa đầu vào check
     */processTermDeposit:function processTermDeposit(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/termDeposit"),body);},/* * Thực hiện rút tiết kiệm
     * {
     *  "accountId": "0001000002",
     *  "savingNumber": "012312412432" // Số sổ tiết kiệm
     *  "amount": "1000000" // Số lượng rút
     *  "desc": "MÔ TẢ"
     * }
     */processDepositWithdraw:function processDepositWithdraw(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/depositWithdraw"),body);},/**
     * Thực hiện chuyển tiết kiệm
     * {
     *  "accountId": "0001000002",
     *  "savingNumber": "012312412432" // Số sổ tiết kiệm
     *  "buyingPower": "Y" // Tự động rút sổ để mua
     * }
     */processDepositTransfer:function processDepositTransfer(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/depositTransfer"),data);},/**
     * Thực hiện đăng kí SMS OTP
     * {
     *  "custodycd": Số tài khoản
     *  "tokenNumber": SĐT đăng kí OTP mới
     * }
     */changeAuthNumber:function changeAuthNumber(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{registerBody:null};var registerBody=data.registerBody;return axios.post('/tran/changeAuthMobile',registerBody);},/**
     * Thực hiện gia hạn tiết kiệm
     * {
     *  "savingNumber": "012312412432" // Số sổ tiết kiệm
     *  "autornd": "Y" // Tự động gia hạn
     * }
     */processDepositExtend:function processDepositExtend(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/depositExtend"),data);},/**
   * Check Thay đổi số điện thoại giao dịch bằng điện thoại 
   */checkChangeTradePhone:function checkChangeTradePhone(accountId,checkChangeTradePhoneBody){return axios.post("/tran/accounts/".concat(accountId,"/checkChangeTradePhone"),checkChangeTradePhoneBody);},/**
     * Thay đổi số điện thoại giao dịch bằng điện thoại 
     */changeTradePhone:function changeTradePhone(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/changeTradePhone"),data);},/**
     * Pecheck bán chứng khoán lô lẻ
     * @param {*} accountId Tiểu khoản
     * @param {*} transferBody body precheck
     * @returns 
     */checkSellOddlot:function checkSellOddlot(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkSellOddlot"),transferBody);},/**
     * Thực hiện bán chứng khoán lô lẻ
     * @param {} data 
     * @returns 
     */processSellOddlotTransfer:function processSellOddlotTransfer(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/sellOddlot"),data);},/**
     * Precheck hủy bán chứng khoán lô lẻ
     * @param {*} accountId 
     * @param {*} transferBody 
     * @returns 
     */checkCancelSellOddlot:function checkCancelSellOddlot(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkCancelSellOddlot"),transferBody);},/**
     * Hủy bán chứng khoán lô lẻ
     * @param {*} data 
     * @returns 
     */processCancelSellOddlot:function processCancelSellOddlot(data){var accountId=data.accountId;return axios.post("/tran/accounts/".concat(accountId,"/cancelSellOddlot"),data);},/**
     * Precheck giao dịch chứng khoán nội bộ
     * @param {*} accountId 
     * @param {*} transferBody 
     * @returns 
     */checkStockTransferInternal:function checkStockTransferInternal(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/checkStockTransfer"),transferBody);},/**
     * Giao dịch chứng khoán nội bộ
     * @param {*} data 
     * @returns 
     */processStockTransferInternal:function processStockTransferInternal(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/stockTransfer"),body);},/**
   * check Change password
   */checkChangePassword:function checkChangePassword(accountId,data){return axios.post("/tran/accounts/".concat(accountId,"/checkChangePass"),data);},/**
    * check Change password
    */processChangePassword:function processChangePassword(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/changePass",body);},genOtpChangedPhone:function genOtpChangedPhone(data){return axios.post("/tran/genOtpChangedPhone",data);},//     /**
//    * check Change email/ address
//    */
//     checkChangeCustInfo(accountId, data) {
//         return axios.post(`/tran/accounts/${accountId}/checkCustInfo`, data);
//     },
//     /**
//     * check Change email
//     */
//     processChangeEmail(data) {
//         return axios.post(`/tran/editCustInfo`, data);
//     },
/**
    * Precheck tất toán HĐ hỗ trợ lãi suất
    * @param {*} accountId 
    * @returns 
    */checkPortfolioInterestRate:function checkPortfolioInterestRate(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkDepositWithdraw"),body);},/**
     * Tất toán HĐ hỗ trợ lãi suất
     * {
     *  "tdacctno"
     *  "withdrawamt",
     *  "tokenid"
     *  "transactionId",
     *  "code"
     * }
     */portfolioInterestRate:function portfolioInterestRate(data){return axios.post("/tran/accounts/".concat(data.accountId,"/depositWithdraw"),data);},/**
    * precheck thực hiện hỗ trợ lãi suất
    */checkPerformInterestRateSupport:function checkPerformInterestRateSupport(accountId,data){return axios.post("/tran/accounts/".concat(accountId,"/checkTermDeposit"),data);},/**
    * thực hiện hỗ trợ lãi suất
    */performInterestRateSupport:function performInterestRateSupport(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/termDeposit"),body);},/**
    * thực hiện đổi địa chỉ liên hệ
    */processChangeAddress:function processChangeAddress(data){return axios.post("/tran/editAddress",data);},/**
    * Precheck thông tin hold/unhold BIDV
    * @param {*} accountId 
    * @returns 
    */checkHoldBank:function checkHoldBank(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkHoldbank"),body);},/**
     * Hold/Unhold tiền từ BIDV
     */processHoldBank:function processHoldBank(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(data.accountId,"/holdbank"),body);},/**
    * Precheck bật tắt IFlex
    * @returns 
    */checkToggleiFlex:function checkToggleiFlex(body){return axios.post("/tran/checkToggleiFlex",body);},/**
     * Bật tắt IFlex
     */processToggleiFlex:function processToggleiFlex(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/toggleiFlex",body);},/**
    * Precheck Đăng ký tự động IFlex
    * @returns 
    */checkAutoIFlex:function checkAutoIFlex(id,body){return axios.post("/tran/checkRegisteriFlex",body);},/**
     * Xử lý đăng ký tự động IFlex
     */processAutoIFlex:function processAutoIFlex(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/registeriFlex",body);},/**
    * Precheck Đăng ký gói Voucher
    * @returns 
    * */checkRegisterVoucher:function checkRegisterVoucher(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkRegisterVoucher"),body);},/**
     * Xử lý Đăng ký gói Voucher
     */processRegisterVoucher:function processRegisterVoucher(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/registerVoucher"),body);},/**
   * Precheck Đăng ký mua IPO
   * @returns 
   * */checkRegisterOrderCW:function checkRegisterOrderCW(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkRegisterOrderCW"),body);},/**
     * Xử lý Đăng ký mua IPO
     */processRegisterOrderCW:function processRegisterOrderCW(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/registerOrderCW"),body);},/**
     * Precheck Thay đổi tt
     * const FLDNAMES_VALID = [
     *"DATEOFBIRTH",  //ngày sinh
     *"MOBILESMS",  //số điện thoại di động
     *"MOBILE",  //số điện thoại cố định  
     *"EMAIL",  //email
     *"SEX",  //giới tính
     *"ADDRESS"]  //địa chỉ
     * @returns 
     * */checkChangeCustInfo:function checkChangeCustInfo(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkCustInfo"),body);},/**
     * Xác thực số điện thoại khách hàng
     */verifyChangedPhone:function verifyChangedPhone(data){return axios.post("/tran/verifyChangedPhone",data);},//data { code , phone}
/**
     * Xử lý Thay đổi tt
     */processChangeCustInfo:function processChangeCustInfo(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/editCustInfo",body);},/**
    * Đăng ký SMS
    */processRegisterSMSService:function processRegisterSMSService(data){return axios.post("/tran/RegisterSMSService",data);},/**
    * preCheck đăng ký ngân hàng thụ hưởng
    * @returns 
    * */checkRegisterAccTransfer:function checkRegisterAccTransfer(body){return axios.post("/tran/checkRegisterAccTransfer",body);},/**
     *  Thực hiện Đăng ký ngân hàng thụ hưởng
     */processRegisterAccTransfer:function processRegisterAccTransfer(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/registerAccTransfer",body);},/**
    * preCheck xóa ngân hàng thụ hưởng
    * @returns 
    * */checkRemoveBeneficiary:function checkRemoveBeneficiary(body){return axios.post("/tran/checkRemoveBeneficiary",body);},/**
     *  Xóa ngân hàng thụ hưởng
     */processRemoveBeneficiary:function processRemoveBeneficiary(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/removeBeneficiary",body);},/**
    * preCheck Tự động chuyền tiền BIDV 
    */checkRegisterAutoCashtransCorebank:function checkRegisterAutoCashtransCorebank(accountId,body){return axios.post("/tran/accounts/".concat(accountId,"/checkRegisterAutoCashtransCorebank"),body);},/**
     *  Tự động chuyển tiền BIDV
     */processRegisterAutoCashtransCorebank:function processRegisterAutoCashtransCorebank(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/registerAutoCashtransCorebank"),body);},/**
     *  check thực hiện thay đổi gói chính sách
     */checkChangePolicy:function checkChangePolicy(){return axios.post("/tran/preCheckChangePolicy");},/**
     *  thực hiện thay đổi gói chính sách
     */processChangePolicyCareBy:function processChangePolicyCareBy(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/ChangePolicyCareBy",body);},/**
    * preCheck Xóa data thiết bị đã xác minh v3
    */checkRemoveVerifiedDevice:function checkRemoveVerifiedDevice(body){return axios.post("/tran/checkRemoveVerifiedDevice",body);},/**
     *  Xóa data thiết bị đã xác minh v3
     */processRemoveVerifiedDevice:function processRemoveVerifiedDevice(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/removeVerifiedDevice",body);},/**
    * preCheck Xóa data thiết bị đã xác minh v1
    */checkRemoveRefreshToken:function checkRemoveRefreshToken(body){return axios.post("/tran/refreshtoken/checkdelete",body);},/**
     *  Xóa data thiết bị đã xác minh v1
     */processRemoveRefreshToken:function processRemoveRefreshToken(data){var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/refreshtoken/delete",body);},changeTradeTelephoneStatus:function changeTradeTelephoneStatus(data){return axios.post("/tran/registerTradeTelephone",data);},processPayMXV:function processPayMXV(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/depositIMCash"),body);},processWithdrawMXV:function processWithdrawMXV(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/withdrawIMCash"),body);},/**
     * Đăng ký tài khoản demo
     * @param {*} data 
     * @returns 
     */registerDemoAccount:function registerDemoAccount(data){var body={initbalance:data===null||data===void 0?void 0:data.initbalance};return axios.post("tran/createDemoAccount",body);},/**
     * Cấp số dư tài khoản ảo
     * @param {*} data 
     * @returns 
     */virtualBalance:function virtualBalance(data){var body={accountId:data===null||data===void 0?void 0:data.accountId,amount:data===null||data===void 0?void 0:data.amount};return axios.post("tran/virtualBalance",body);},/**
     * reset số dư tài khoản ảo
     * @param {*} data 
     * @returns 
     */resetDemoAccount:function resetDemoAccount(data){var body={accountId:data===null||data===void 0?void 0:data.accountId// amount: data?.amount,
};return axios.post("tran/resetDemoAccount",body);},/**
    * Đăng ký tài khoản chưa ekyc
    * 
    */createAccount:function createAccount(data){var body={"email":(data===null||data===void 0?void 0:data.email)||null,"fullname":(data===null||data===void 0?void 0:data.fullname)||null,"dateofbirth":(data===null||data===void 0?void 0:data.dateofbirth)||null,"phone":(data===null||data===void 0?void 0:data.phone)||null,"sex":(data===null||data===void 0?void 0:data.sex)||null,"branch":(data===null||data===void 0?void 0:data.branch)||null,"accountNumber":(data===null||data===void 0?void 0:data.accountNumber)||null,"broker_id":(data===null||data===void 0?void 0:data.broker_id)||null,"custodycd":(data===null||data===void 0?void 0:data.accountNumber)||null};return axios.post("/tran/createAccount",body);},/**
    * Rút tiền tài khoản future
    * 
    */withdrawFutureAccount:function withdrawFutureAccount(data){var body={"custodycd":data.custodycd,"bank_name":data.bank_name,"bank_no":data.bank_no,"branch_name":data.branch_name,"amount":data.amount,"desc":data.desc};return axios.post("/tran/email/transferBank",body);},/**
    * Rút tiền tài khoản nano
    * 
    */transferNanoAccount:function transferNanoAccount(data){var body={"custodycd":data.custodycd,"amount":data.amount,"desc":data.desc};return axios.post("/tran/email/transferNano",body);},/**
     * Precheck đăng ký sản phẩm margin
     * @param {*} data 
     * @returns 
     */preCheckMarginProductRegister:function preCheckMarginProductRegister(data){var accountId=data.accountId;var body={"custodycd":data.custodycd,"lntype":data.lntype};return axios.post("/tran/accounts/".concat(accountId,"/preChecklnRegister"),body);},/**
     * Đăng ký sản phẩm margin
     * @param {*} data 
     * @returns 
     */processMarginProductRegister:function processMarginProductRegister(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/lnRegister"),body);},/**
     * Lấy số tiền vay
     * @param {*} accountId 
     * @param {*} amount 
     * @returns 
     */getImLoan:function getImLoan(accountId,amount){return axios.get("/inq/accounts/".concat(accountId,"/getimloan?amount=").concat(amount));},preCheckUnregisterMarginProduct:function preCheckUnregisterMarginProduct(data){var accountId=data.accountId;var body={"lnactype":data.lnactype};return axios.post("/tran/accounts/".concat(accountId,"/preChecklnUnregister"),body);},/**
     * Đăng ký sản phẩm margin
     * @param {*} data 
     * @returns 
     */processUnregisterMarginProduct:function processUnregisterMarginProduct(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/lnUnregister"),body);},getBankQrcodeList:function getBankQrcodeList(){return axios.get("/tran/bankQrcodeList");},/**
     * gen qr msb
     * @param {*} data 
     * @returns 
     */genFmoneyQrcodeMSB:function genFmoneyQrcodeMSB(data){var queryParams={"acqId":(data===null||data===void 0?void 0:data.acqId)||"","accountNumber":data===null||data===void 0?void 0:data.accountId,"amount":data===null||data===void 0?void 0:data.amount,"remark":data===null||data===void 0?void 0:data.desc,"accountName":data===null||data===void 0?void 0:data.accountName};return axios.post("/fmoney/msb/payment/qrcode?"+queryString.stringify(queryParams));},checkDerivativeWithdraw:function checkDerivativeWithdraw(accountId,data){return axios.post("/tran/accounts/".concat(accountId,"/checkwithdrawIMCash"),data);},/**
     * Thực hiện gửi yêu cầu tạo môi giới mới lên server
     * @param {*} data 
     * @returns 
     */registerBroker:function registerBroker(data){return axios.post("tran/system/remast/openapi/create",data);},/**
     * Lấy thông tin chi nhánh theo brokerId
     * @param {*} brokerId 
     * @returns 
     */getBranchByBrokerId:function getBranchByBrokerId(brokerId){return axios.get("/tran/tree/branch/byBrokerId?pageindex=1&pagesize=10&broker_id=".concat(brokerId));},/**
     * Lấy thông tin môi giới theo brokerId
     * @param {*} brokerId 
     * @returns 
     */getBrokerNameById:function getBrokerNameById(brokerId){return axios.get("/tran/system/remast/openapi?pageindex=1&pagesize=10&broker_id=".concat(brokerId));},/* 
    * Kiểm tra thông tin trước khi đăng ký làm môi giới
    * @param {*} data 
    */checkOpenBroker:function checkOpenBroker(data){return axios.post("/ekyc/checkOpenBroker",data);},/**
     * Lấy rank config theo brokerId
     * @param {*} brokerId 
     * @returns 
     */getBrokerRankConfig:function getBrokerRankConfig(brokerId){return axios.get("/tran/tree/broker-tree/rank/config?broker_id=".concat(brokerId));},/**
     * Lấy account format từ số điện thoại
     * @param {*} mobile 
     * @returns 
     */getAccountFormatByPhone:function getAccountFormatByPhone(mobile){return axios.get("/tran/tree/account-format?mobile=".concat(mobile));},/**
     * Lấy account format từ số điện thoại
     * @param {*} mobile 
     * @param {*} dateofbirth 
     * @returns 
     */getGenAccountEkyc:function getGenAccountEkyc(data){var queryParams={"brokerid":(data===null||data===void 0?void 0:data.brokerid)||"","tree_id":(data===null||data===void 0?void 0:data.tree_id)||"","phone":(data===null||data===void 0?void 0:data.phone)||"","dateofbirth":(data===null||data===void 0?void 0:data.dateofbirth)&&moment(data===null||data===void 0?void 0:data.dateofbirth).format(config.app.SERVER_DATE_FORMAT)};return axios.get("/tran/genAccount?"+queryString.stringify(queryParams));},/**
     * Danh sách ngân hàng
     * @param accountId Account identifier
     */getBankList:function getBankList(){// change baseurl to test call
return axios.get("tran/getBanklist");},/**
     * lấy thông tin người ủy quyền
     * @param accountId Account identifier
     */getCustomerCfauth:function getCustomerCfauth(){// change baseurl to test call
return axios.get("tran/customer/cfauth");},/**
    * Precheck Đăng ký tự động IFlex
    * @returns 
    */checkPhysicalDeliveryRegister:function checkPhysicalDeliveryRegister(body){var accountId=body.accountId;return axios.post("/tran/accounts/".concat(accountId,"/physical/check-delivery-register"),body);},/**
     * Xử lý đăng ký tự động IFlex
     */processPhysicalDeliveryRegister:function processPhysicalDeliveryRegister(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/physical/delivery/request"),body);},/**
    * Precheck Đăng ký tự động IFlex
    * @returns 
    */checkPhysicalDeliveryDelete:function checkPhysicalDeliveryDelete(body){var accountId=body.accountId;return axios.post("/tran/accounts/".concat(accountId,"/physical/check-delivery-delete"),body);},/**
     * Xử lý đăng ký tự động IFlex
     */processPhysicalDeliveryDelete:function processPhysicalDeliveryDelete(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/physical/delivery/delete"),body);},/**
     * Yêu cầu đăng ký vật chất
     * @param accountId Account identifier
     * @param qrContent id qr
     */requestOriginProduct:function requestOriginProduct(data){var accountId=data.accountId,qrContent=data.qrContent;var body={qrContent:qrContent};return axios.post("/tran/accounts/".concat(accountId,"/physical/traceability/request?"),body);},/**
    * Precheck Đăng ký tự động IFlex
    * @returns 
    */checkConfirmReceiveAssign:function checkConfirmReceiveAssign(body){var accountId=body.accountId;return axios.post("/tran/accounts/".concat(accountId,"/physical/designated/check-register"),body);},/**
     * Xử lý đăng ký tự động IFlex
     */processConfirmReceiveAssign:function processConfirmReceiveAssign(data){var accountId=data.accountId;var body=_objectSpread({},data,{isSaveVerify:CommonUtils.getSaveVerifiedSession()});return axios.post("/tran/accounts/".concat(accountId,"/physical/designated/register"),body);}};export default transferService;